import React, { useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Background, Page, Subpage, Images, Content, Table, Breaker, Title } from "./style";
import Prefeitura from "../../../assets/Images/prefeitura.jpg";
import Fiec from "../../../assets/Images/fiec.png";
import PdfButtons from "../../../components/PdfButtons";

export default function PdfAtribuicaoAula() {
  const [atribuicoes, setAtribuicoes] = useState([]);
  const location = useLocation();
  const ref = useRef();

  useEffect(() => {
    if (location.state.atribuicoes) {
      setAtribuicoes(location.state.atribuicoes || []);
    }
  }, [location?.state]);

  return (
    <Background>
      <PdfButtons />
      <Page>
        <Subpage>
          <Breaker ref={ref}>
            <Images>
              <img src={Fiec} alt="FIEC Logo" />
              <img src={Prefeitura} alt="Prefeitura Logo" />
            </Images>
            <Content>
              <Title>Detalhes da Carga Horária por Colaborador</Title>
              {atribuicoes?.length > 0 &&
                atribuicoes.map((a, i) => {
                  return (
                    <div>
                      <h3>{a.nome}</h3>
                      <Table key={a.matricula}>
                        <thead>
                          <tr>
                            <th>Curso</th>
                            <th>Centro Custo</th>
                            <th>Componente Curricular</th>
                            <th>Carga Horária</th>
                          </tr>
                        </thead>
                        <tbody>
                          {a.dados.map((d, i) => {
                            const carga = d.carga ? Number(d.carga.toFixed(2)) : 0;
                            return (
                              <tr key={i}>
                                <td className="curso" data-title="Curso" value={d.id_curso}>
                                  {d.curso}
                                </td>
                                <td className="centro_custo" data-title="Centro Custo" value={d.centro_custo} title={d.id_centro_custo}>
                                  {d.centro_custo}
                                </td>
                                <td className="disciplina" data-title="Disciplina" value={d.disciplina} title={d.id_disciplina}>
                                  {d.disciplina}
                                </td>
                                <td className="carga" data-title="Carga Horária" value={carga} title={carga}>
                                  {carga}
                                </td>
                              </tr>
                            );
                          })}
                          <tr>
                            <td style={{ border: 0, backgroundColor: "#fff", padding: 0 }} colSpan={2}></td>
                            <td>
                              <strong>Carga Horária Total:</strong>
                            </td>
                            <td>{a.total ? Number(a.total.toFixed(2)) : 0}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  );
                })}
            </Content>
          </Breaker>
        </Subpage>
      </Page>
    </Background>
  );
}
